import { useState } from 'react'
import { UsageIntelligencePanel as UsageAnalyticsPanel } from './UsageAnalyticsPanel'
import { ClimateIntelligencePanel } from './ClimateIntelligencePanel'
import { OperationalIntelligencePanel } from './OperationalIntelligencePanel'

type IntelligenceView = 'usage' | 'operational' | 'climate'

export function UsageIntelligencePanel() {
  const [view, setView] = useState<IntelligenceView>('usage')

  return (
    <section className="usage-intelligence-hub">
      <div className="usage-view-switch" role="tablist" aria-label="Visões da Inteligência do Suite">
        <button type="button" role="tab" aria-selected={view === 'usage'} className={view === 'usage' ? 'active' : ''} onClick={() => setView('usage')}>
          <strong>Uso do Suite</strong>
          <small>Acessos, sessões, módulos e adoção</small>
        </button>
        <button type="button" role="tab" aria-selected={view === 'operational'} className={view === 'operational' ? 'active' : ''} onClick={() => setView('operational')}>
          <strong>Inteligência Operacional</strong>
          <small>Unidades, buscas, resolutividade, releases e alertas</small>
        </button>
        <button type="button" role="tab" aria-selected={view === 'climate'} className={view === 'climate' ? 'active' : ''} onClick={() => setView('climate')}>
          <strong>Clima Presencial</strong>
          <small>Sentimento agregado das lojas de atendimento</small>
        </button>
      </div>

      {view === 'usage' && <UsageAnalyticsPanel />}
      {view === 'operational' && <OperationalIntelligencePanel />}
      {view === 'climate' && <ClimateIntelligencePanel />}
    </section>
  )
}
